import { createSlice } from '@reduxjs/toolkit';

import { locationChange } from './actions';
import type RouterState from './types/RouterState';

const PREVIOUS_LOCATIONS_TO_KEEP = 10;

const initialState: RouterState = {
  location: null,
  action: null,
  previousLocations: [],
};

const routerSlice = createSlice({
  name: 'router',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(locationChange, (state, { payload }) => ({
      location: payload.location,
      action: payload.action,
      previousLocations: [payload, ...state.previousLocations.slice(0, PREVIOUS_LOCATIONS_TO_KEEP)],
    }));
  },
});

export default routerSlice;
